import type { TooltipProps, TypographyProps } from "@mui/material";
import { Tooltip } from "@mui/material";
import type { PropsWithChildren } from "react";
import TypographyMultilineEllipsis from "@entrilia/shared/components/TypographyMultilineEllipsis";
import useVerticalOverflowContainerDetection from "@entrilia/shared/hooks/useVerticalOverflowContainerDetection";

interface Props {
  maxLines: number;
  tooltipProps?: Partial<TooltipProps>;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
  typographyProps?: TypographyProps;
}
const GroupNamesMultilineEllipsis = ({
  maxLines,
  typographyProps,
  children,
  tooltipProps,
  tooltipPlacement,
}: PropsWithChildren<Props>) => {
  const resolvedTooltipPlacement = tooltipPlacement ?? "bottom";
  const { hasOverflow, containerRef } = useVerticalOverflowContainerDetection([children]);

  return (
    <Tooltip
      {...tooltipProps}
      title={hasOverflow ? (tooltipProps?.title ?? "") : ""}
      placement={resolvedTooltipPlacement}
      arrow
    >
      <TypographyMultilineEllipsis maxLines={maxLines} typographyProps={typographyProps} ref={containerRef}>
        {children}
      </TypographyMultilineEllipsis>
    </Tooltip>
  );
};

export default GroupNamesMultilineEllipsis;
